<template>
    <div>
        <common-table :table-columns="tableColumns"
                      :form-fields="formFields"
                      :permission="permission"
                      :url="url"
                      :operate="[]"
                      :searchs="searchs"
        />
    </div>
</template>

<script>
    import CommonTable from "../../components/CommonTable/CommonTable";
    export default {
        name: "InvestmentStatistics",
        components: { CommonTable },
        data() {
            return {
                searchs: [{
                    name: 'agentId',
                    placeholder: '代理',
                    type: 'select',
                    selectUrl: '/agent/getAll',
                    selectData: [],
                }, {
                    name: 'phone',
                    placeholder: '用户',
                    type: 'input'
                }],
                permission: {
                    /*add: 'userDailyInvestmentIncome:add',
                    update: 'userDailyInvestmentIncome:update',
                    delete: 'userDailyInvestmentIncome:delete',
                    deleteBatch: 'userDailyInvestmentIncome:deleteBatch'*/
                },
                url: {
                    get: '/investmentStatistics/listByCondition',
                    /*add: '/userDailyInvestmentIncome/add',
                    update: '/userDailyInvestmentIncome/update',
                    delete: '/userDailyInvestmentIncome/delete',
                    delete_batch: '/userDailyInvestmentIncome/deleteBatch',*/
                },
                tableColumns: [{
                    field: 'id',
                    label: 'ID',
                    show: true,
                    width: '',
                }, {
                    field: 'agentId',
                    label: '代理',
                    selectUrl: '/agent/getAll',
                    selectData: [],
                    show: {
                        type: 'select',
                    },
                    detail: false,
                    width: '',
                }, {
                  field: 'phone',
                  label: '用户',
                  show: true,
                  width: '',
                }, {
                    field: 'days',
                    label: '有效天数',
                    show: true,
                    width: '',
                }, {
                  field: 'recharge',
                  label: '充值金额',
                  show: true,
                  width: '',
                }, {
                    field: 'amount',
                    label: '已收益',
                    show: true,
                    width: '',
                }, {
                    field: 'isReturn',
                    label: '已退返',
                    show: true,
                    width: '',
                }, {
                    field: 'createTime',
                    label: '创建时间',
                    show: true,
                    width: '',
                }],
                formFields: {
                    model: []
                }
            }
        }
    }
</script>

<style scoped>

</style>
